import call from './call';
import {GET_CERTIFICATE_INFO} from "../types";

export default (form) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
                dispatch({type: GET_CERTIFICATE_INFO, payload: {certificateInfo:result[1].certInfo}});
    };
    dispatch(call("CertificateService/getCertificateInfo",form,onResult));
};